import { __assign, __makeTemplateObject } from "tslib";
import styled from '../../styled-components';
import React, { useMemo } from 'react';
import { logInDev } from '../../utils';
var FOCUSABLE_QUERY = '[data-focusable="true"]';
/**
 * non size for just render hidden element
 */
export var RcFocusInside = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 0;\n  height: 0;\n"], ["\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 0;\n  height: 0;\n"])));
/**
 * focus always inside the container which `[data-focusable="true"]`
 */
export var useFocusInside = function (options) {
    if (options === void 0) { options = {}; }
    var containerRef = options.containerRef, _a = options.selector, selector = _a === void 0 ? FOCUSABLE_QUERY : _a;
    return useMemo(function () {
        var start = (React.createElement(RcFocusInside, __assign({ tabIndex: 0 }, (process.env.NODE_ENV !== 'production'
            ? { 'data-test-automation-id': 'focus-inside-start' }
            : undefined), { onFocus: function (e) {
                var container = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || e.target.parentElement;
                var nodes = container === null || container === void 0 ? void 0 : container.querySelectorAll(selector);
                if (nodes) {
                    var last = nodes[nodes.length - 1];
                    last.focus();
                }
                else if (process.env.NODE_ENV !== 'production') {
                    logInDev({
                        component: 'useFocusInside',
                        message: 'Not found any [data-focusable="true"] element in container, please check your containerRef',
                        level: 'warn',
                    });
                }
            } })));
        var end = (React.createElement(RcFocusInside, __assign({ tabIndex: 0 }, (process.env.NODE_ENV !== 'production'
            ? { 'data-test-automation-id': 'focus-inside-end' }
            : undefined), { onFocus: function (e) {
                var container = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || e.target.parentElement;
                var node = container === null || container === void 0 ? void 0 : container.querySelector(selector);
                if (node) {
                    node === null || node === void 0 ? void 0 : node.focus();
                }
                else if (process.env.NODE_ENV !== 'production') {
                    logInDev({
                        component: 'useFocusInside',
                        message: 'Not found any [data-focusable="true"] element in container, please check your containerRef',
                        level: 'warn',
                    });
                }
            } })));
        return {
            start: start,
            end: end,
        };
    }, [containerRef, selector]);
};
var templateObject_1;
